import { createContext } from "react";

const AppContext = createContext<any>(null);

export default AppContext;
